import { create } from "zustand";

interface IAlert {
  isOpen: boolean;
  message: string;
  severity: "error" | "warning" | "info" | "success";
}

interface IStore {
  alert: IAlert;
  setAlert: (alert: IAlert) => void;
}

export const useAlert = create<IStore>()((set) => ({
  alert: {
    isOpen: false,
    message: "",
    severity: "info",
  },
  setAlert: (alert) => {
    set({ alert });
  },
}));
